import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";

export type DashboardSummaryCard = {
  id: string;
  title: ReactNode;
  value: ReactNode;
  loading?: boolean;
  icon: string;
  link: string;
};

type DashboardSummaryCardsProps = {
  cards: DashboardSummaryCard[];
};

const DashboardSummaryCards = ({ cards }: DashboardSummaryCardsProps) => (
  <div className="dashboard-summary-cards mb-4">
    {cards.map((card) => (
      <Link
        key={card.id}
        className="summary-card-link"
        to={card.link}
        style={{ textDecoration: "none", color: "inherit" }}
      >
        <div
          className="summary-card border bg-white d-flex justify-content-between align-items-center p-3"
          style={{ borderRadius: "8px", cursor: "pointer" }}
        >
          <div>
            <p className="mb-1" style={{ fontSize: "24px", fontWeight: 600 }}>
              {card.loading ? <Skeleton width={50} /> : card.value}
            </p>
            <h6 className="opacity-50 m-0">{card.title}</h6>
          </div>
          <div>
            <img src={card.icon} alt="" style={{ width: "50px", height: "50px" }} />
          </div>
        </div>
      </Link>
    ))}
  </div>
);

export default DashboardSummaryCards;
